/**
 * @author: subhasish.ghosh@zoom.us
 */

import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, TextField } from "@mui/material";
import { getOneYearAgo, getToday } from "@utils/utils";

const DateRangePicker = ({ onDateChange }) => {
  const startLimit = getOneYearAgo();
  const endLimit = getToday();

  const [startDate, setStartDate] = useState(startLimit);
  const [endDate, setEndDate] = useState(endLimit);

  const handleStartDateChange = (newValue) => {
    if (newValue && newValue.isAfter(endDate)) {
      setEndDate(newValue);
    }
    setStartDate(newValue);
    if (onDateChange) {
      onDateChange({
        startDate: newValue,
        endDate: newValue && newValue.isAfter(endDate) ? newValue : endDate,
      });
    }
  };

  const handleEndDateChange = (newValue) => {
    setEndDate(newValue);
    if (onDateChange) {
      onDateChange({ startDate, endDate: newValue });
    }
  };

  return (
    <Box display="flex" gap={0.5}>
      <DatePicker
        label="Start Date"
        value={startDate}
        onChange={handleStartDateChange}
        maxDate={endLimit}
        minDate={startLimit}
        renderInput={(params) => <TextField {...params} />}
      />
      <DatePicker
        label="End Date"
        value={endDate}
        onChange={handleEndDateChange}
        maxDate={endLimit}
        minDate={startDate || startLimit}
        renderInput={(params) => <TextField {...params} />}
      />
    </Box>
  );
};

export default DateRangePicker;
